import { DbListBase } from "./db-list-base";
import { DbObjectBase } from "./db-object-base";
import { ICollectionReference } from '../database-cast/IDatabase';
import { Customer } from '../../../core/_shared/models/Customer';
import { DbCustomer } from './db-customer';
import { Method } from '../../../core/_shared/models/method';
import { DbMethod } from './db-method';
import { MethodTask } from '../../../core/_shared/models/method-task';



export class DbMethods extends DbListBase<Method> {

  
    constructor(collection: ICollectionReference) {
        super(collection);
       
    }

  public getMethod(id: string): DbMethod {
    return new DbMethod(id,this._collection);
  }
}




